import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.875 8.571h15.75M5.911 2v1.714M17.375 2v1.714m3.375 3V19a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3V6.714a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3"
    />
  </svg>
);
export default SvgCalendar011;
